import { Modal } from "antd";
import React, { useRef, useState } from "react";
import Draggable from "react-draggable";

const CustomModal = (props) => {
  const draggleRef = useRef(null);
  const [disabled, setDisabled] = useState(true);
  const [bounds, setBounds] = useState({
    // 預設位置邊界為0
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
  });

  // onStart 函式計算了拖動的邊界
  const onStart = (_event, uiData) => {
    const { clientWidth, clientHeight } = window.document.documentElement;
    const targetRect = draggleRef.current?.getBoundingClientRect();
    if (!targetRect) {
      return;
    }
    // 指定屏幕上下左右四個位置邊界限制
    setBounds({
      left: -targetRect.left + uiData.x,
      right: clientWidth - (targetRect.right - uiData.x),
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - (targetRect.bottom - uiData.y),
    });
  };

  return (
    <Modal
      maskClosable={false} //点击蒙层是否允许关闭
      destroyOnClose //关闭时销毁 Modal 里的子元素
      footer={null}
      {...props}
      title={
        <div
          className="w-full cursor-move"
          onMouseOver={() => {
            if (disabled) {
              setDisabled(false);
            }
          }}
          onMouseOut={() => {
            setDisabled(true);
          }}
        >
          {props.title}
        </div>
      }
      modalRender={(modal) => (
        <Draggable
          disabled={disabled}
          bounds={bounds}
          onStart={(event, uiData) => onStart(event, uiData)}
        >
          <div ref={draggleRef}>{modal}</div>
        </Draggable>
      )}
    >
      {props.children}
    </Modal>
  );
};
export default CustomModal;
